import React from 'react'
import { Link } from '@sentecacommerce-theme/lib'
import styled from 'styled-components'
import { Typography } from '../Typography'

type Props = {
  emptyBasketOrWishlistText: string
  emptyBasketOrWishlistCallToAction: string
  className?: string
}

export const EmptyBasketAndWishlist: React.FC<Props> = ({
  emptyBasketOrWishlistText,
  emptyBasketOrWishlistCallToAction,
  className,
  children,
}) => {
  return (
    <EmptyBasketAndWishlistContainer className={className}>
      <Content variant="6">{emptyBasketOrWishlistText}</Content>
      <Link href="/" passHref>
        <ActionButton>
          <Typography variant="6">
            {emptyBasketOrWishlistCallToAction}
          </Typography>
        </ActionButton>
      </Link>
    </EmptyBasketAndWishlistContainer>
  )
}

const Content = styled(Typography)<any>`
  color: ${({ theme }) => theme.palette.greyTitle};
`

const EmptyBasketAndWishlistContainer = styled.div.attrs<{ className: string }>(
  {
    className: 'd-flex flex-column align-items-center justify-content-center',
  }
)``

const ActionButton = styled.a.attrs({ className: 'mt-5 py-3 px-5' })`
  color: ${({ theme }) => theme.palette.greyTitle};
  text-align: center;

  border: 1px solid ${({ theme }) => theme.palette.greyTitle};
  border-radius: 0.3rem;
  font-weight: normal;
  font-size: 1.4rem;

  transition: transform 0.3s, background-color 0.3s, opacity 0.3s;

  &:hover {
    background-color: rgba(233, 245, 232, 0.5);
  }
`
